<template>
	<div class="holiday-alert-wrap">
		<el-alert class="holiday-alert" type="warning" show-icon>
			<p slot="title" class="holiday-alert-title">
				1024热门产品套餐直降，充3万得5万，充5万得10万，优惠折上折！<a target="_blank" :href="baseUrl + '/activities/1024/recharge?ch=1024console'">活动详情&gt;&gt;</a>
			</p>
		</el-alert>
	</div>
</template>
<script>
export default {
  name: 'HolidayAlert',
  computed: {
    baseUrl () {
      return Url[Mode].baseUrl
    }
	}
}
</script>
<style>
	.el-alert__icon {
		line-height: 23px;
	}
	.el-alert__icon.is-big {
		display: table-cell;
	}
	.el-alert__content {
    vertical-align: middle;
	}
</style>

<style scoped>
	.holiday-alert-wrap .el-alert--warning.is-light {
		border-radius: 0px;
		padding: 5px 16px;
		border-bottom: solid 1px #f5e3bf;
		align-items: flex-start;
	}
	.holiday-alert-wrap .el-alert--warning.is-light .holiday-alert-title {
		color: #f93;
		line-height: 1.8;
	}
	a {
		color: #409EFF;
	}
</style>




// WEBPACK FOOTER //
// app/components/HolidayAlert/Main.vue